import React, { useState, useEffect, useRef } from 'react';
import { Tooltip, TooltipArrow, TooltipInner } from './Tooltip.styles';

export const SimpleTooltip = ({ active = false, left, top, children, hasAbsolutePosition = false }) => {
    const el = useRef(null);
    const [dimensions, setDimensions] = useState({ height: 0, width: 0 });

    useEffect(() => {
        if (el.current) {
            const height = el.current.clientHeight;
            const width = el.current.clientWidth;
            setDimensions({ height, width });
        }
    }, []); // Empty dependency array to run once after the initial render

    const { height, width } = dimensions;
    const centerPos = { top, left };

    const offset = 2;
    let arrowPosFromLeft = 50 - offset;
    let arrowFrom = 'top';

    if (top && left) {
        centerPos.top = top - height;
        centerPos.left = left - width / 2;

        const containerWidth = window.document.body.clientWidth;
        const isOverLeftSide = left < width / 2;
        const isOverRigthSide = left + width / 2 > containerWidth;

        const convertToPercent = (fromLeft) => (fromLeft * 100) / width - offset;

        if (isOverLeftSide) {
            arrowPosFromLeft = convertToPercent(left);
            centerPos.left = 0;
        } else if (isOverRigthSide) {
            const tooltipStartPos = containerWidth - width;
            const arrowPosInsideTooltip = left - tooltipStartPos;
            arrowPosFromLeft = convertToPercent(arrowPosInsideTooltip);
            centerPos.left = containerWidth - width;
        }

        // The 'isOverTopSide' check is no longer needed, as it's always false
        if (false) {
            arrowFrom = 'bottom';
            centerPos.top = top;
        }
    } else {
        centerPos.top = -height;
    }

    return (
        <Tooltip
            data-testid="simple-tooltip"
            ref={el}
            active={active}
            style={{
                top: `${centerPos.top}px`,
                left: `${centerPos.left}px`,
                position: hasAbsolutePosition ? 'absolute' : 'fixed',
            }}>
            <TooltipArrow
                arrowPosFromLeft={arrowPosFromLeft}
                top={arrowFrom === 'top'}
                bottom={arrowFrom === 'bottom'}
            />
            <TooltipInner top={arrowFrom === 'top'} bottom={arrowFrom === 'bottom'}>
                {children}
            </TooltipInner>
        </Tooltip>
    );
};
